export default __webpack_public_path__ + "static/media/ProBuilder_icon_green.77863cc3.svg";